import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from '@aws-amplify/auth';
import { NbCardModule, NbIconModule } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { SpinnerComponent } from 'src/app/shared/ui/spinner/spinner.component';
import { ENVIRONMENT } from 'src/environments/environment';
import { SetIsLogedIn, SetUserGroups, SetUsername } from '../redux';

@Component({
  selector: 'app-okta-redirect',
  templateUrl: './okta-redirect.component.html',
  styleUrls: ['./okta-redirect.component.css'],
  imports: [SpinnerComponent, NbCardModule, NgIf, NbIconModule]
})
export class OktaRedirectComponent implements OnInit {
  public accessDenied = false;
  public environment = ENVIRONMENT.name;

  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  public ngOnInit() {
    if (this.route.snapshot.queryParams.error === 'access_denied') {
      this.accessDenied = true;
    } else {
      Auth.currentSession()
        .then((session) => {
          const payload = session.getIdToken().payload;
          this.store.dispatch([
            new SetUsername(payload.email),
            new SetUserGroups(JSON.parse(payload['custom:groups'])),
            new SetIsLogedIn(true)
          ]);
          this.router.navigateByUrl('/quick-start');
        })
        .catch((error) => {
          this.router.navigateByUrl('/login');
        });
    }
  }
}
